import axios from 'axios';
import { useState, useEffect } from 'react';
import { apiConstant } from '../../constant';
import lodash from 'lodash';
import {
  spotWelding,
  projectionWelding,
  pnumeticPress,
  powerPress,
} from './checklist';

const useGetData = (
  id: string | undefined,
  checkSheetType: string | undefined
) => {
  const [moduleData, setModuleData] = useState<any>({});
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const checkSheetdata: any = {
    c1: lodash.cloneDeep(spotWelding),
    c2: lodash.cloneDeep(projectionWelding),
    c3: lodash.cloneDeep(pnumeticPress),
    c4: lodash.cloneDeep(powerPress),
  };

  useEffect(() => {
    setIsLoading(true);
    if (id) {
      axios
        .get(`/api/${apiConstant.checklistData}/${id}`)
        .then((res) => {
          setModuleData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          setError(err);
          setIsLoading(false);
        });
    } else {
      setModuleData({
        checkSheetType: checkSheetType,
        c: lodash.cloneDeep(checkSheetdata[checkSheetType as string]),
      });
    }
  }, [checkSheetType]);

  return { moduleData, isLoading, error };
};

export default useGetData;
